<div class="map-inset">
  <app-map
    width="200px"
    height="200px"
    [links]="links"
    [highlight]="highlight"
    [inset]="true"
  ></app-map>
</div>
